/** Pragmatic format check for shareholder / notification addresses (not full RFC 5322). */
const EMAIL_FORMAT_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

export const INVALID_EMAIL_MESSAGE = 'Enter a valid email address (e.g. name@company.com).';

export const isValidEmail = (value: string): boolean => {
  const email = value.trim();
  if (!email || email.length > 254) return false;
  return EMAIL_FORMAT_RE.test(email);
};
